function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "padlock",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    d: "M21.47,43.09c-2.44-1.41-4.41.09-4.41,3.34a11.27,11.27,0,0,0,2.26,6.45v8.86l4.3,2.48V55.35c1.35-.23,2.26-1.62,2.26-3.83C25.88,48.27,23.88,44.52,21.47,43.09Zm10-1V31c0-6.29-4.4-13.95-9.87-17.1s-9.92-.62-9.94,5.67V30.6L31.44,42Zm6.39,3.7,4.43,2.56-.14,33.8L.68,58.14.8,24.32l4.42,2.55V16.55C5.27,6.2,12.59,2,21.6,7.23S37.88,25,37.85,35.38Z",
    style: {
      fill: "#fabb05"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    points: "11.63 30.6 19.7 25.89 31.47 32.7 31.44 42.03 11.63 30.6",
    style: {
      fill: "#ffdf7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    d: "M19.7,13c-4.56-1.61-8,1-8,6.55V30.62l8.06-4.7Z",
    style: {
      fill: "#ed8c03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    d: "M45.87,41V30.65c0-10.35-7.24-23-16.25-28.15C25.1-.1,21-.34,18,1.4L10.08,6c2.64-1.49,6.17-1.42,10.09.45.47.22.94.46,1.42.74,9,5.2,16.28,17.8,16.25,28.15V45.69h0l8-4.72Z",
    style: {
      fill: "#ffdf7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    points: "42.23 48.28 42.24 48.29 42.21 58.54 42.13 82.11 50.19 77.4 50.31 43.59 50.27 43.57 42.23 48.28",
    style: {
      fill: "#ed8c03"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    points: "45.9 41.04 37.85 45.76 42.23 48.28 50.27 43.57 45.9 41.04",
    style: {
      fill: "#ffd357"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.3d1ce5122dfc05ab23cbb53bf583ad36.svg";
export { ForwardRef as ReactComponent };